import React from 'react';
import { useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import './addPaymentCardsMobile.scss';
import usePayment from '../../../core/payment/usePayment';
import { getTranslation } from '../../../core/utils/helpers';
import useLanguage from '../../../core/language/useLanguage';
import StripeElementsWrapper from '../../../components/StripeElementsWrapper';
import StripeCardForm from '../../../components/StripeCardForm';

const CheckoutForm = ({ type, lifeEvents }) => {
    const { addPaymentCardRequest, payment } = usePayment();
    const { language } = useLanguage();
    const user = useSelector(state => state.user.userData);

    const handleSubmit = ({ token, card }) => {
        addPaymentCardRequest({
            token,
            card,
            user_id: user?.id,
            type,
            horoscopeDataParts: lifeEvents,
            selectedLang: language?.selectedLanguage?.id,
            payment_type: 'web',
        });
    };

    const languageLabels = {
        cardNumberLabel: getTranslation(language, 'payment_card_form_card_number_label', 'Card Number:'),
        holdersNameLabel: getTranslation(language, 'payment_card_form_holders_name_label', "Cardholder's Name:"),
        holdersNameRequired: getTranslation(language, 'payment_card_form_holders_name_valid_required', "Please enter Cardholder's Name!"),
        expiryLabel: getTranslation(language, 'payment_card_form_card_exp_date_label', 'Expiry Date'),
        cvcLabel: getTranslation(language, 'payment_card_form_card_cvc_label', 'Security Code:'),
    };

    return (
        <StripeElementsWrapper>
            <StripeCardForm
                onSubmit={handleSubmit}
                loading={payment.isFetching}
                buttonLabel={getTranslation(language, 'payment_card_form_pay_button_label', 'Pay')}
                language={languageLabels} />
        </StripeElementsWrapper>
    );
};

CheckoutForm.propTypes = {
    type: PropTypes.string,
    lifeEvents: PropTypes.arrayOf(PropTypes.number),
};

CheckoutForm.defaultProps = {
    type: '',
    lifeEvents: [],
};

export default CheckoutForm;
